import * as React from "react";

import {
    formatDateWithTimezone,
    formatTimeAndTimezone,
} from "@impero-com/common/utils/formatting";

import { IanaTimezoneView } from "api/generated/model";

interface DateFormatterProps {
    dateInfo: DateAndTimezone;
    showTime?: boolean;
}

interface DateAndTimezone {
    utcDate: Date;
    timezone: IanaTimezoneView;
}

class DateFormatter extends React.PureComponent<DateFormatterProps> {
    render = () => {
        const { dateInfo, showTime } = this.props;
        const { utcDate, timezone } = dateInfo;
        if (!utcDate || !timezone) {
            return null;
        }
        return (
            <div>
                <div>{formatDateWithTimezone(utcDate, timezone)}</div>
                {showTime ? (
                    <div>{formatTimeAndTimezone(utcDate, timezone)}</div>
                ) : null}
            </div>
        );
    };
}

export { type DateAndTimezone, DateFormatter };
